export default __webpack_public_path__ + "static/media/1222.2072837e.png";